<app-edit-list-dialog></app-edit-list-dialog>
<opac-confirmation-dialog
  [acceptLabel]="'general.exit'"
  [cancelLabel]="'general.cancel'"
  [open]="editingFacade.isEditingModalOpen$ | async"
  [title]="'editing.modal.title' | translate"
  (accept)="editingFacade.setCloseResult(true)"
  (cancel)="editingFacade.setCloseResult(false)">
  <p>{{'editing.modal.message' | translate}}</p>
</opac-confirmation-dialog>
<opac-confirmation-dialog
  [acceptLabel]="'general.goToTheWebSite'"
  [cancelLabel]="'general.cancel'"
  [open]="errorDialogFacade.open$ | async"
  [title]="'messages.information' | translate"
  (accept)="errorDialogFacade.openUrl()"
  (cancel)="errorDialogFacade.closeDialog()">
  <p>{{ (errorDialogFacade.content$ | async) | translate }}</p>
</opac-confirmation-dialog>
<opac-confirmation-dialog
  [acceptLabel]="undefined"
  [cancelLabel]="'general.close'"
  [open]="helpButtonFacade.open$ | async"
  [title]="(helpButtonFacade.title$ | async) | translate"
  (cancel)="helpButtonFacade.closeDialog()">
  <p>{{ (helpButtonFacade.content$ | async) | translate }}</p>
</opac-confirmation-dialog>
<opac-citation-dialog></opac-citation-dialog>
<opac-report-dialog></opac-report-dialog>
<opac-external-video-dialog></opac-external-video-dialog>
<opac-rating-dialog></opac-rating-dialog>
<opac-info-dialog></opac-info-dialog>
<opac-bookclub-links-dialog></opac-bookclub-links-dialog>
<opac-amautas-subscription-dialog
  [open]="amautasSubscriptionDialogFacade.open$ | async"
  (accept)="amautasSubscriptionDialogFacade.openUrl()"
  (cancel)="amautasSubscriptionDialogFacade.closeDialog()">
</opac-amautas-subscription-dialog>
<opac-cookies-dialog></opac-cookies-dialog>